import type { LucideIcon } from 'lucide-react'
import { memo, type ReactNode } from 'react'

import { Button } from '@/components/ui/button'

interface DataTablePaginationButtonProps {
  icon: LucideIcon
  label: string
  isDisabled: boolean
  onClick: () => void
  className: string
}

/**
 * A single pagination navigation button with icon and screen reader label.
 */
const DataTablePaginationButtonBase: React.FC<DataTablePaginationButtonProps> = ({
  icon: Icon,
  label,
  isDisabled,
  onClick,
  className,
}): ReactNode => (
  <Button
    variant="outline"
    size="icon"
    className={className}
    disabled={isDisabled}
    onClick={onClick}
  >
    <Icon className="size-4" />
    <span className="sr-only">{label}</span>
  </Button>
)

export const DataTablePaginationButton = memo(DataTablePaginationButtonBase)

DataTablePaginationButton.displayName = 'DataTablePaginationButton'
